module.exports = __webpack_public_path__ + "static/media/warning.d791e79c.svg";